import { useContext } from 'react';
import { CadastroProducaoContextData } from '../types';
import { CadastroProducaoContext } from '../context/CadastroProducaoContext';

export const useCadastroProducao = (): CadastroProducaoContextData =>
  useContext(CadastroProducaoContext);
